import { render, staticRenderFns } from "./Patterns.vue?vue&type=template&id=c49ede26&scoped=true&"
import script from "./Patterns.vue?vue&type=script&lang=js&"
export * from "./Patterns.vue?vue&type=script&lang=js&"
import style0 from "./Patterns.vue?vue&type=style&index=0&id=c49ede26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49ede26",
  null
  
)

export default component.exports